import required from "vuelidate/lib/validators/required";
import store from "@state/store";

import FieldSelect from "@components/molecules/m-field-select.vue";

export default {
  component: FieldSelect,
  attrs: {
    label: "Escolha seu nome na lista",
    name: "vendedor",
    values: store.getters["catalog/sellers"],
    placeholder: "Selecione seu nome",
    type: "select",
    required: true,
  },
  errorMessages: [
    {
      name: "required",
      message: "Selecione uma opção.",
    },
  ],
  validation: {
    required,
  },
};
